<template>
  <div class="privacy-page">
    <!-- 背景装饰 -->
    <div class="page-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <!-- 主要内容 -->
    <div class="privacy-container">
      <!-- 头部 -->
      <div class="privacy-header">
        <div class="header-content">
          <div class="title-section">
            <i class="title-icon">🔒</i>
            <h1>隐私协议</h1>
            <p>Privacy Policy</p>
          </div>
          <div class="header-decoration">
            <div class="decoration-line"></div>
            <div class="decoration-dot"></div>
            <div class="decoration-line"></div>
          </div>
        </div>
        <div class="header-meta">
          <div class="meta-item">
            <i class="meta-icon">📅</i>
            <span>最后更新：2026年3月</span>
          </div>
          <div class="meta-item">
            <i class="meta-icon">⏱️</i>
            <span>阅读时间：约10分钟</span>
          </div>
          
        </div>
      </div>

      <!-- 目录导航 -->
      <div class="toc-sidebar">
        <div class="toc-card">
          <div class="toc-header">
            <i class="toc-icon">📑</i>
            <h3>目录导航</h3>
          </div>
          <nav class="toc-nav">
            <a href="#p1" class="toc-link">一. 引言</a>
            <a href="#p2" class="toc-link">二. 信息收集</a>
            <a href="#p3" class="toc-link">三. 信息使用</a>
            <a href="#p4" class="toc-link">四. 信息共享</a>
            <a href="#p5" class="toc-link">五. 用户权利</a>
            <a href="#p6" class="toc-link">六. 信息安全</a>
            <a href="#p7" class="toc-link">七. 未成年人保护</a>
            <a href="#p8" class="toc-link">八. 协议更新</a>
            <a href="#p9" class="toc-link">九. 联系我们</a>
          </nav>
        </div>
      </div>

      <!-- 协议内容 -->
      <div class="privacy-content">
        <div class="content-card">
          <!-- 引言部分 -->
          <div class="article-intro">
            <div class="intro-icon">👋</div>
            <p>欢迎使用京游科技（北京）有限公司（以下简称"我们"）的产品和服务。我们深知个人信息对您的重要性，并庄严承诺保护您的个人信息安全。本隐私协议旨在说明我们如何收集、使用、存储、共享和保护您的个人信息。</p>
          </div>

          <!-- 协议正文 -->
          <div class="article-content">
            <!-- 一. 引言 -->
            <section id="p1" class="content-section">
              <div class="section-header">
                <span class="section-number">01</span>
                <h2>引言</h2>
              </div>
              <div class="section-content">
                <div class="important-notice">
                  <div class="notice-header">
                    <i class="notice-icon">💡</i>
                    <span>重要提示</span>
                  </div>
                  <p class="highlight-text">请您在使用我们的产品或服务前，仔细阅读并充分理解本隐私协议的全部内容。一旦您开始使用我们的产品或服务，即表示您已同意我们按照本协议的规定处理您的个人信息。</p>
                </div>
                
                <div class="definition-list">
                  <div class="definition-item">
                    <span class="def-term">【个人信息】</span>
                    <span class="def-desc">指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span>
                  </div>
                  <div class="definition-item">
                    <span class="def-term">【个人敏感信息】</span>
                    <span class="def-desc">指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。</span>
                  </div>
                  <div class="definition-item">
                    <span class="def-term">【去标识化】</span>
                    <span class="def-desc">指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别特定自然人的过程。</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- 二. 信息收集 -->
            <section id="p2" class="content-section">
              <div class="section-header">
                <span class="section-number">02</span>
                <h2>信息收集</h2>
              </div>
              <div class="section-content">
                <div class="clause-group">
                  <h4>我们收集的信息类型</h4>
                  <p>在您使用我们的服务过程中，我们会收集以下类型的信息：</p>
                  
                  <div class="info-cards">
                    <div class="info-card">
                      <i class="info-icon">👤</i>
                      <h5>账户信息</h5>
                      <p>您在注册账户时提供的姓名、手机号码、电子邮箱等</p>
                    </div>
                    <div class="info-card">
                      <i class="info-icon">📱</i>
                      <h5>设备信息</h5>
                      <p>设备型号、操作系统版本、唯一设备标识符等</p>
                    </div>
                    <div class="info-card">
                      <i class="info-icon">📍</i>
                      <h5>位置信息</h5>
                      <p>IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点等</p>
                    </div>
                    <div class="info-card">
                      <i class="info-icon">📊</i>
                      <h5>日志信息</h5>
                      <p>浏览和点击记录、搜索查询、崩溃报告等</p>
                    </div>
                  </div>

                  <div class="collection-methods">
                    <h4>信息收集方式</h4>
                    <div class="method-list">
                      <div class="method-item">
                        <i class="method-icon">✅</i>
                        <span>您直接提供的信息</span>
                      </div>
                      <div class="method-item">
                        <i class="method-icon">✅</i>
                        <span>在您使用服务过程中收集的信息</span>
                      </div>
                      <div class="method-item">
                        <i class="method-icon">✅</i>
                        <span>从第三方获取的您的信息</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- 三. 信息使用 -->
            <section id="p3" class="content-section">
              <div class="section-header">
                <span class="section-number">03</span>
                <h2>信息使用</h2>
              </div>
              <div class="section-content">
                <div class="usage-grid">
                  <div class="usage-item">
                    <i class="usage-icon">🎯</i>
                    <div class="usage-content">
                      <h5>提供服务</h5>
                      <p>为您提供个性化内容推荐和优化服务体验</p>
                    </div>
                  </div>
                  <div class="usage-item">
                    <i class="usage-icon">🔧</i>
                    <div class="usage-content">
                      <h5>产品优化</h5>
                      <p>分析和改进我们的产品和服务质量</p>
                    </div>
                  </div>
                  <div class="usage-item">
                    <i class="usage-icon">📢</i>
                    <div class="usage-content">
                      <h5>信息通知</h5>
                      <p>向您发送重要通知和个性化推广信息</p>
                    </div>
                  </div>
                  <div class="usage-item">
                    <i class="usage-icon">🛡️</i>
                    <div class="usage-content">
                      <h5>安全保障</h5>
                      <p>用于身份验证、安全防范、存档备份等</p>
                    </div>
                  </div>
                </div>

                <div class="legal-basis">
                  <h4>法律依据</h4>
                  <p class="highlight-text">我们仅在法律法规允许、您明确授权或为履行合同所必需的范围内使用您的个人信息。如我们需要将个人信息用于本政策未载明的其他用途，我们将另行征得您的同意。</p>
                </div>
              </div>
            </section>

            <!-- 四. 信息共享 -->
            <section id="p4" class="content-section">
              <div class="section-header">
                <span class="section-number">04</span>
                <h2>信息共享</h2>
              </div>
              <div class="section-content">
                <div class="sharing-rules">
                  <p>我们不会与任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
                  
                  <div class="sharing-list">
                    <div class="sharing-item">
                      <div class="sharing-icon">🤝</div>
                      <div class="sharing-desc">
                        <strong>获得您的明确同意</strong>
                        <span>在获得您的明确同意后，我们会与其他方共享您的信息</span>
                      </div>
                    </div>
                    <div class="sharing-item">
                      <div class="sharing-icon">⚖️</div>
                      <div class="sharing-desc">
                        <strong>法律法规要求</strong>
                        <span>根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求</span>
                      </div>
                    </div>
                    <div class="sharing-item">
                      <div class="sharing-icon">🛡️</div>
                      <div class="sharing-desc">
                        <strong>保护用户安全</strong>
                        <span>为保护我们及其关联公司用户或公众的人身财产安全免遭侵害</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-transfer">
                  <h4>数据转移</h4>
                  <p class="highlight-text">我们不会将您的个人信息转移给任何公司、组织或个人，但以下情况除外：</p>
                  <ul class="clause-list">
                    <li>在获取明确同意的情况下转移</li>
                    <li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束</li>
                  </ul>
                </div>
              </div>
            </section>

            <!-- 五. 用户权利 -->
            <section id="p5" class="content-section">
              <div class="section-header">
                <span class="section-number">05</span>
                <h2>用户权利</h2>
              </div>
              <div class="section-content">
                <div class="rights-cards">
                  <div class="right-card">
                    <i class="right-icon">👁️</i>
                    <h5>访问权</h5>
                    <p>您有权访问您的个人信息，法律法规规定的例外情况除外</p>
                  </div>
                  <div class="right-card">
                    <i class="right-icon">✏️</i>
                    <h5>更正权</h5>
                    <p>您有权更正或更新不准确或不完整的个人信息</p>
                  </div>
                  <div class="right-card">
                    <i class="right-icon">🗑️</i>
                    <h5>删除权</h5>
                    <p>在特定情况下，您有权要求删除您的个人信息</p>
                  </div>
                  <div class="right-card">
                    <i class="right-icon">⏸️</i>
                    <h5>限制处理权</h5>
                    <p>在某些情况下，您有权限制我们处理您的个人信息</p>
                  </div>
                </div>

                <div class="rights-process">
                  <h4>权利行使方式</h4>
                  <p>如您希望行使上述权利，请通过本政策列明的联系方式与我们联系。我们将在15个工作日内回复您的请求。</p>
                </div>
              </div>
            </section>

            <!-- 六. 信息安全 -->
            <section id="p6" class="content-section">
              <div class="section-header">
                <span class="section-number">06</span>
                <h2>信息安全</h2>
              </div>
              <div class="section-content">
                <div class="security-card">
                  <i class="security-icon">🔒</i>
                  <div class="security-content">
                    <p>我们谨守保护您个人信息及隐私的基本准则。我们对相关信息采取专业加密存储与传输方式，利用合理措施保障您个人信息的安全。</p>
                  </div>
                </div>

                <div class="security-measures">
                  <h4>安全措施</h4>
                  <div class="measures-grid">
                    <div class="measure-item">
                      <i class="measure-icon">🔐</i>
                      <span>数据加密</span>
                    </div>
                    <div class="measure-item">
                      <i class="measure-icon">🛡️</i>
                      <span>访问控制</span>
                    </div>
                    <div class="measure-item">
                      <i class="measure-icon">📋</i>
                      <span>安全审计</span>
                    </div>
                    <div class="measure-item">
                      <i class="measure-icon">🚨</i>
                      <span>应急响应</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- 七. 未成年人保护 -->
            <section id="p7" class="content-section">
              <div class="section-header">
                <span class="section-number">07</span>
                <h2>未成年人保护</h2>
              </div>
              <div class="section-content">
                <div class="minor-protection">
                  <p class="highlight-text">我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您家长或法定监护人的书面同意。</p>
                  
                  <div class="protection-features">
                    <div class="feature-item">
                      <i class="feature-icon">👨‍👩‍👧‍👦</i>
                      <span>家长监护</span>
                    </div>
                    <div class="feature-item">
                      <i class="feature-icon">📵</i>
                      <span>内容过滤</span>
                    </div>
                    <div class="feature-item">
                      <i class="feature-icon">⏰</i>
                      <span>使用时长限制</span>
                    </div>
                    <div class="feature-item">
                      <i class="feature-icon">💰</i>
                      <span>消费保护</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- 八. 协议更新 -->
            <section id="p8" class="content-section">
              <div class="section-header">
                <span class="section-number">08</span>
                <h2>协议更新</h2>
              </div>
              <div class="section-content">
                <div class="update-notice">
                  <p>我们的隐私协议可能变更。未经您明确同意，我们不会削减您按照本隐私协议所应享有的权利。</p>
                  
                  <div class="update-rules">
                    <h4>更新规则</h4>
                    <ul class="clause-list">
                      <li>对于重大变更，我们会提供显著的通知</li>
                      <li>本政策所指的重大变更包括但不限于服务模式发生重大变化等</li>
                      <li class="highlight-text">如您不同意更新后的内容，应立即停止使用相关服务；如您继续使用，即视为知悉变动内容并同意接受</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

         
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacy",
  mounted() {
    document.title = "京游科技（北京）有限公司";
    
    // 添加滚动监听高亮目录
    this.setupTocHighlight();
  },
  methods: {
    setupTocHighlight() {
      const sections = document.querySelectorAll('.content-section');
      const links = document.querySelectorAll('.toc-link');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            links.forEach(link => {
              link.classList.remove('active');
              if (link.getAttribute('href') === `#${id}`) {
                link.classList.add('active');
              }
            });
          }
        });
      }, { threshold: 0.5 });
      
      sections.forEach(section => observer.observe(section));
    },
    
    handleConfirm() {
      alert('感谢您阅读并同意我们的隐私协议！');
      // 这里可以添加实际的确认逻辑，比如设置cookie或更新用户状态
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.privacy-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow-x: hidden;

  // 背景装饰
  .page-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    
    .bg-shape {
      position: absolute;
      border-radius: 50%;
      background: rgba(102, 126, 234, 0.05);
      animation: float 8s ease-in-out infinite;
      
      &.shape-1 {
        width: 200px;
        height: 200px;
        top: 10%;
        left: 5%;
        animation-delay: 0s;
      }
      
      &.shape-2 {
        width: 150px;
        height: 150px;
        top: 60%;
        right: 10%;
        animation-delay: 2s;
        animation-direction: reverse;
      }
      
      &.shape-3 {
        width: 100px;
        height: 100px;
        bottom: 20%;
        left: 15%;
        animation-delay: 4s;
      }
    }
  }

  .privacy-container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;

    // 头部
    .privacy-header {
      text-align: center;
      margin-bottom: 50px;
      
      .header-content {
        .title-section {
          margin-bottom: 30px;
          
          .title-icon {
            font-size: 64px;
            display: block;
            margin-bottom: 20px;
            background: linear-gradient(135deg, #667eea, #764ba2);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
          }
          
          h1 {
            font-size: 42px;
            font-weight: 700;
            color: #1a1a1a;
            margin: 0 0 10px 0;
            background: linear-gradient(135deg, #667eea, #764ba2);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          p {
            font-size: 18px;
            color: #666;
            margin: 0;
            font-weight: 500;
          }
        }
        
        .header-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin-bottom: 30px;
          
          .decoration-line {
            width: 60px;
            height: 2px;
            background: linear-gradient(90deg, #667eea, #764ba2);
            border-radius: 1px;
          }
          
          .decoration-dot {
            width: 8px;
            height: 8px;
            background: #667eea;
            border-radius: 50%;
            animation: pulse 2s infinite;
          }
        }
      }
      
      .header-meta {
        display: flex;
        justify-content: center;
        gap: 30px;
        
        .meta-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 20px;
          font-size: 14px;
          color: #666;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          
          .meta-icon {
            font-size: 16px;
          }
        }
      }
    }

    // 目录侧边栏
    .toc-sidebar {
      position: sticky;
      top: 100px;
      float: left;
      width: 280px;
      margin-right: 40px;
      
      .toc-card {
        background: #fff;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
        
        .toc-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 2px solid #f0f0f0;
          
          .toc-icon {
            font-size: 20px;
            background: linear-gradient(135deg, #667eea, #764ba2);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          h3 {
            font-size: 18px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0;
          }
        }
        
        .toc-nav {
          display: flex;
          flex-direction: column;
          gap: 8px;
          
          .toc-link {
            padding: 12px 16px;
            color: #666;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.3s ease;
            font-size: 14px;
            font-weight: 500;
            
            &:hover {
              color: #667eea;
              background: rgba(102, 126, 234, 0.05);
              transform: translateX(4px);
            }
            
            &.active {
              color: #667eea;
              background: rgba(102, 126, 234, 0.1);
              font-weight: 600;
              border-left: 3px solid #667eea;
            }
          }
        }
      }
    }

    // 协议内容
    .privacy-content {
      margin-left: 320px;
      
      .content-card {
        background: #fff;
        border-radius: 20px;
        padding: 50px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
        
        // 引言
        .article-intro {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          padding: 30px;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
          border-radius: 16px;
          margin-bottom: 40px;
          border-left: 4px solid #667eea;
          
          .intro-icon {
            font-size: 32px;
            margin-top: 4px;
          }
          
          p {
            font-size: 16px;
            line-height: 1.7;
            color: #595959;
            margin: 0;
            font-weight: 500;
          }
        }

        // 内容区块
        .content-section {
          margin-bottom: 60px;
          scroll-margin-top: 100px;
          
          .section-header {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 2px solid #f0f0f0;
            
            .section-number {
              font-size: 48px;
              font-weight: 700;
              color: #e6f7ff;
              background: linear-gradient(135deg, #667eea, #764ba2);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              line-height: 1;
            }
            
            h2 {
              font-size: 28px;
              font-weight: 700;
              color: #1a1a1a;
              margin: 0;
            }
          }
          
          .section-content {
            // 定义列表
            .definition-list {
              display: flex;
              flex-direction: column;
              gap: 16px;
              
              .definition-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                padding: 16px;
                background: #f8f9fa;
                border-radius: 8px;
                border-left: 4px solid #667eea;
                
                .def-term {
                  font-weight: 600;
                  color: #667eea;
                  min-width: 120px;
                }
                
                .def-desc {
                  color: #595959;
                  line-height: 1.6;
                }
              }
            }
            
            // 信息卡片网格
            .info-cards {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
              gap: 20px;
              margin: 20px 0;
              
              .info-card {
                text-align: center;
                padding: 30px 20px;
                background: #f8f9fa;
                border-radius: 12px;
                transition: all 0.3s ease;
                border: 2px solid transparent;
                
                &:hover {
                  transform: translateY(-4px);
                  border-color: #667eea;
                  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
                }
                
                .info-icon {
                  font-size: 32px;
                  margin-bottom: 16px;
                  display: block;
                }
                
                h5 {
                  font-size: 18px;
                  font-weight: 600;
                  color: #1a1a1a;
                  margin: 0 0 12px 0;
                }
                
                p {
                  font-size: 14px;
                  color: #666;
                  line-height: 1.5;
                  margin: 0;
                }
              }
            }
            
            // 使用方法列表
            .method-list {
              display: flex;
              flex-direction: column;
              gap: 12px;
              margin: 20px 0;
              
              .method-item {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 12px 16px;
                background: rgba(102, 126, 234, 0.05);
                border-radius: 8px;
                border-left: 4px solid #667eea;
                
                .method-icon {
                  font-size: 16px;
                  color: #52c41a;
                }
                
                span {
                  color: #595959;
                  font-weight: 500;
                }
              }
            }
            
            // 使用场景网格
            .usage-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
              gap: 20px;
              margin: 20px 0;
              
              .usage-item {
                display: flex;
                align-items: flex-start;
                gap: 16px;
                padding: 20px;
                background: #f8f9fa;
                border-radius: 12px;
                transition: all 0.3s ease;
                
                &:hover {
                  background: rgba(102, 126, 234, 0.05);
                  transform: translateY(-2px);
                }
                
                .usage-icon {
                  font-size: 24px;
                  margin-top: 4px;
                }
                
                .usage-content {
                  h5 {
                    font-size: 16px;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin: 0 0 8px 0;
                  }
                  
                  p {
                    font-size: 14px;
                    color: #666;
                    line-height: 1.5;
                    margin: 0;
                  }
                }
              }
            }
            
            // 共享信息列表
            .sharing-list {
              display: flex;
              flex-direction: column;
              gap: 16px;
              margin: 20px 0;
              
              .sharing-item {
                display: flex;
                align-items: flex-start;
                gap: 16px;
                padding: 20px;
                background: rgba(255, 152, 0, 0.05);
                border-radius: 12px;
                border-left: 4px solid #ff9800;
                
                .sharing-icon {
                  font-size: 24px;
                  margin-top: 4px;
                }
                
                .sharing-desc {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  
                  strong {
                    color: #e65100;
                    font-weight: 600;
                  }
                  
                  span {
                    color: #595959;
                    line-height: 1.5;
                  }
                }
              }
            }
            
            // 权利卡片
            .rights-cards {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 20px;
              margin: 20px 0;
              
              .right-card {
                text-align: center;
                padding: 25px 20px;
                background: #f8f9fa;
                border-radius: 12px;
                transition: all 0.3s ease;
                
                &:hover {
                  background: rgba(102, 126, 234, 0.05);
                  transform: translateY(-2px);
                }
                
                .right-icon {
                  font-size: 32px;
                  margin-bottom: 16px;
                  display: block;
                }
                
                h5 {
                  font-size: 16px;
                  font-weight: 600;
                  color: #1a1a1a;
                  margin: 0 0 8px 0;
                }
                
                p {
                  font-size: 13px;
                  color: #666;
                  line-height: 1.4;
                  margin: 0;
                }
              }
            }
            
            // 安全卡片
            .security-card {
              display: flex;
              align-items: flex-start;
              gap: 20px;
              padding: 24px;
              background: rgba(102, 126, 234, 0.05);
              border-radius: 12px;
              border: 1px solid rgba(102, 126, 234, 0.2);
              margin: 20px 0;
              
              .security-icon {
                font-size: 32px;
                margin-top: 4px;
              }
              
              .security-content {
                p {
                  margin: 0;
                  line-height: 1.6;
                  color: #595959;
                }
              }
            }
            
            // 安全措施网格
            .measures-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
              gap: 16px;
              margin: 20px 0;
              
              .measure-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
                padding: 20px 16px;
                background: #f8f9fa;
                border-radius: 8px;
                transition: all 0.3s ease;
                
                &:hover {
                  background: rgba(102, 126, 234, 0.05);
                  transform: translateY(-2px);
                }
                
                .measure-icon {
                  font-size: 24px;
                }
                
                span {
                  font-size: 14px;
                  font-weight: 500;
                  color: #595959;
                  text-align: center;
                }
              }
            }
            
            // 保护功能网格
            .protection-features {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
              gap: 16px;
              margin: 20px 0;
              
              .feature-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
                padding: 20px 16px;
                background: rgba(255, 193, 7, 0.05);
                border-radius: 8px;
                border: 1px solid rgba(255, 193, 7, 0.2);
                
                .feature-icon {
                  font-size: 24px;
                }
                
                span {
                  font-size: 14px;
                  font-weight: 500;
                  color: #595959;
                  text-align: center;
                }
              }
            }
            
            // 联系信息
            .contact-info {
              .contact-card {
                display: flex;
                align-items: flex-start;
                gap: 20px;
                padding: 24px;
                background: rgba(102, 126, 234, 0.05);
                border-radius: 12px;
                margin-bottom: 20px;
                
                .contact-icon {
                  font-size: 32px;
                  margin-top: 4px;
                }
                
                .contact-details {
                  h5 {
                    font-size: 18px;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin: 0 0 8px 0;
                  }
                  
                  p {
                    margin: 0;
                    color: #595959;
                    line-height: 1.5;
                  }
                }
              }
              
              .contact-methods {
                display: flex;
                flex-direction: column;
                gap: 12px;
                
                .contact-method {
                  display: flex;
                  align-items: center;
                  gap: 12px;
                  padding: 12px 16px;
                  background: #f8f9fa;
                  border-radius: 8px;
                  
                  .method-icon {
                    font-size: 18px;
                    color: #667eea;
                  }
                  
                  span {
                    color: #595959;
                    font-weight: 500;
                  }
                }
              }
            }
            
            // 条款列表
            .clause-list {
              list-style: none;
              padding: 0;
              
              li {
                padding: 12px 0 12px 24px;
                position: relative;
                line-height: 1.6;
                color: #595959;
                
                &::before {
                  content: '•';
                  position: absolute;
                  left: 8px;
                  color: #667eea;
                  font-weight: bold;
                }
                
                &.highlight-text {
                  background: rgba(255, 152, 0, 0.05);
                  padding: 16px;
                  border-radius: 8px;
                  border-left: 4px solid #ff9800;
                  font-weight: 600;
                  color: #e65100;
                }
              }
            }
            
            // 重要通知
            .important-notice {
              padding: 24px;
              background: rgba(102, 126, 234, 0.05);
              border-radius: 12px;
              border: 1px solid rgba(102, 126, 234, 0.2);
              margin-bottom: 20px;
              
              .notice-header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 16px;
                
                .notice-icon {
                  font-size: 20px;
                }
                
                span {
                  font-weight: 600;
                  color: #667eea;
                }
              }
            }
          }
        }

        // 高亮文本
        .highlight-text {
          background: rgba(255, 152, 0, 0.05);
          padding: 16px;
          border-radius: 8px;
          border-left: 4px solid #ff9800;
          font-weight: 600;
          color: #e65100;
          line-height: 1.6;
        }

        // 协议确认
        .privacy-confirm {
          margin-top: 60px;
          padding-top: 40px;
          border-top: 2px solid #f0f0f0;
          
          .confirm-card {
            text-align: center;
            padding: 40px;
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
            border-radius: 16px;
            border: 2px dashed #667eea;
            
            .confirm-icon {
              font-size: 48px;
              display: block;
              margin-bottom: 20px;
              background: linear-gradient(135deg, #667eea, #764ba2);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            
            h4 {
              font-size: 24px;
              font-weight: 600;
              color: #1a1a1a;
              margin: 0 0 16px 0;
            }
            
            p {
              font-size: 16px;
              color: #666;
              line-height: 1.6;
              margin: 0 0 30px 0;
            }
            
            .confirm-actions {
              .confirm-btn {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 16px 32px;
                background: linear-gradient(135deg, #667eea, #764ba2);
                color: #fff;
                border: none;
                border-radius: 12px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                
                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
                }
                
                i {
                  font-size: 18px;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 10px #667eea;
  }
}

// 入场动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-section {
  animation: fadeInUp 0.6s ease forwards;
}

// 响应式设计
@media (max-width: 1024px) {
  .toc-sidebar {
    display: none;
  }
  
  .privacy-content {
    margin-left: 0 !important;
  }
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 20px 16px !important;
  }
  
  .content-card {
    padding: 30px 20px !important;
  }
  
  .header-meta {
    flex-direction: column;
    gap: 12px !important;
  }
  
  .info-cards {
    grid-template-columns: 1fr !important;
  }
  
  .usage-grid {
    grid-template-columns: 1fr !important;
  }
  
  .rights-cards {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .measures-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .protection-features {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 480px) {
  .rights-cards {
    grid-template-columns: 1fr !important;
  }
  
  .measures-grid {
    grid-template-columns: 1fr !important;
  }
  
  .protection-features {
    grid-template-columns: 1fr !important;
  }
}
</style>